import { Modal } from "pepsico-ds";
import "./UnsavedChangesConfirmationModel.scss";

const UnsavedChangesConfirmationModel = ({
  showCancelConfirmationModal,
  setShowCancelConfirmationModal,
  handleCancel,
  handleConfirm,
  title,
  description = "You might have unsaved changes. Are you sure you want to cancel?",
  confirmText = "Continue to edit",
}) => {
  return (
    <Modal
      className="confirmation-modal"
      showModal={showCancelConfirmationModal}
      onCloseModal={() => setShowCancelConfirmationModal(false)}
      primaryButtonProps={{
        size: "medium",
        text: confirmText,
        variant: "primary",
        onClick: () => {
          setShowCancelConfirmationModal(false);
          handleConfirm && handleConfirm();
        },
      }}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: () => {
          setShowCancelConfirmationModal(false);
          handleCancel();
        },
      }}
      showTertiaryButton={false}
      showLink={false}
      title={title}
    >
      <p>{description}</p>
    </Modal>
  );
};

export default UnsavedChangesConfirmationModel;
